import './FileInput.less';
import React, {useState, useEffect, useRef} from 'react';
import __ from "../../i18n";
import Icon from "../../../bootstrap/components/icon/Icon";
import Popup from "../../../bootstrap/components/popup/Popup";
import Request from "../../../bootstrap/api/Request";
import Spinner from '../../../bootstrap/components/spinner/Spinner';
import Sortable from "sortablejs";
import arrayMove from "array-move";
import FilePicker from "../file-picker/FilePicker";

export default function FileInput(
    {
        FileListParcel,
        FileUploadParcel,
        fileAddIcon = 'file-plus',
        defaultValue = [],
        maxFiles = 12,
        maxFileSize,
        allowedMimeTypes,
        allowedExtensions,
        renderThumbnail,
        renderPlaceholder,
        getFileTitle,
        getFileError = (record) => null,
        getSelectedSummary,
        onChange = (value) => undefined,
    }
) {

    const [pickerShown, setPickerShown] = useState(false);

    const [error, setError] = useState(null);

    const [records, setRecords] = useState(null);

    useEffect(() => {
        if (records === null ){
            return;
        }

        onChange(records.map(t => t.id));
    }, [records]);

    const createParcel = () => {
        if (defaultValue.length === 0) {
            return null;
        }

        const filters = [{
            field: 'id',
            operator: 'in_list',
            value: defaultValue
        }];

        const filtersConfig = {
            id: {type: 'number'}
        };

        return new FileListParcel({filters, filtersConfig});
    };

    const loadRecords = () => {
        setError(null);

        const parcel = createParcel();

        if (parcel === null) {
            setRecords([]);
            return;
        }

        Request.add(parcel)
            .then(data => {
                data.items.sort((a, b) => {
                    const ai = defaultValue.indexOf(a.id);
                    const bi = defaultValue.indexOf(b.id);
                    return ai - bi;
                });
                setRecords(data.items);
            })
            .catch(error => {
                setError(error.getMessage());
            });
    };

    useEffect(loadRecords, []);

    const showPicker = () => setPickerShown(true);

    const hidePicker = () => setPickerShown(false);

    const addRecords = (newRecords) => {
        setRecords(records.concat(newRecords));
    };

    const removeRecord = (recordId) => {
        setRecords(records.filter(t => t.id !== recordId));
    };

    return <div className="file-input">
        {
            records === null &&
            error === null &&
            <Spinner/>
        }
        {
            records !== null &&
            <CardContent
                records={records}
                maxFiles={maxFiles}
                requestAdd={showPicker}
                requestRemove={removeRecord}
                updateRecords={setRecords}
                renderThumbnail={renderThumbnail}
                fileAddIcon={fileAddIcon}
            />
        }
        {
            error !== null &&
            <div>
                <span>{error}</span>
                {
                    records === null &&
                    <button
                        type="button"
                        onClick={loadRecords}
                    >
                        {__('Reload')}
                    </button>
                }
            </div>
        }
        {
            pickerShown &&
            <Popup>
                <FilePicker
                    FileUploadParcel={FileUploadParcel}
                    FileListParcel={FileListParcel}
                    maxFiles={maxFiles - (records !== null ? records.length : 0)}
                    maxFileSize={maxFileSize}
                    allowedMimeTypes={allowedMimeTypes}
                    allowedExtensions={allowedExtensions}
                    renderThumbnail={renderThumbnail}
                    renderPlaceholder={renderPlaceholder}
                    getFileTitle={getFileTitle}
                    getFileError={record => {
                        if (records.find(t => record.id === t.id)) {
                            return __('Already selected');
                        }

                        return getFileError(record);
                    }}
                    getSelectedSummary={getSelectedSummary}
                    onDone={(records) => {
                        addRecords(records);
                        hidePicker();
                    }}
                    onCancel={hidePicker}
                />
            </Popup>
        }
    </div>;
}


class CardContent extends React.Component {
    constructor(props) {
        super(props);

        this.listEl = null;
    }

    componentDidMount() {
        new Sortable(this.listEl, {
            draggable: ".draggable",
            onEnd: (ev) => {
                let {oldIndex, newIndex} = ev;

                if (newIndex === oldIndex) {
                    return;
                }

                const {records} = this.props;

                this.props.updateRecords(arrayMove(records, oldIndex, newIndex));
            }
        });
    }

    render() {
        const {records, maxFiles, requestAdd, requestRemove, renderThumbnail, fileAddIcon} = this.props;

        return <div className="card-content">
            <ul ref={el => this.listEl = el}>
                {
                    records.map((record, index) => <li key={record.id} className="draggable">
                        <div className="aspect-ratio-keeper">
                            <div className="thumbnail-wrapper">
                                {renderThumbnail(record)}
                            </div>
                            <button
                                type="button"
                                className="remove-button"
                                onClick={() => requestRemove(record.id)}
                            >
                                <Icon name="times"/>
                            </button>
                        </div>
                    </li>)
                }
                {
                    records.length < maxFiles &&
                    <li>
                        <div className="aspect-ratio-keeper">
                            <div
                                className="adding-pad"
                                onClick={() => requestAdd()}
                            >
                                <Icon name={fileAddIcon}/>
                            </div>
                        </div>
                    </li>
                }
            </ul>
        </div>;
    }
}
